import { render, staticRenderFns } from "./queryStockManage.vue?vue&type=template&id=56ba47cc&scoped=true"
import script from "./queryStockManage.vue?vue&type=script&lang=js"
export * from "./queryStockManage.vue?vue&type=script&lang=js"
import style0 from "./queryStockManage.vue?vue&type=style&index=0&id=56ba47cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ba47cc",
  null
  
)

export default component.exports